<template>
  <div>
    <v-btn color="primary" dark class="mb-2 sbtn" to="/staff/add">{{ $t("staffPage.new") }}</v-btn>
    <DataTable
      :url="api.ACTIONS.STAFF"
      :titles="titles"
      :fields-hidden-main="[
        'deleted_at',
        'updated_at',
        'last_name',
        'profile_image',
        'phone_number',
        'identity',
        'telegram_username',
        'blacklisted_at',
        'blacklist_note',
        'activation_code',
      ]"
      :fields-hidden-add="[
        'id',
        'deleted_at',
        'created_at',
        'updated_at',
        'roles',
        'blacklisted_at',
        'blacklist_note',
      ]"
      :fields-hidden-edit="[
        'id',
        'deleted_at',
        'created_at',
        'updated_at',
        'roles',
        'blacklisted_at',
        'blacklist_note',
        'activation_code',
      ]"
      :input-types-add="{
        password: 'password',
      }"
      :input-types-edit="{
        password: 'password',
      }"
      :fields-extra-add="fieldsExtraAdd"
      :fields-extra-edit="fieldsExtraEdit"
      :fields-extra-main="fieldsExtraMain"
      :formatter="formatters"
      :title="$t('staffPage.pageTitle')"
      :enableEdit="true"
      :enableAdd="false"
      :actions-extra-main="actionsExtraMain"
      load-before-edit
      :edit-extra-data="editExtraData"
    />
  </div>
</template>
<style>
.sbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>
<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import api from "@/constants/api.js";

export default {
  name: "Staff",
  title() {
    return this.$t("staffPage.pageTitle");
  },
  components: { DataTable },
  data() {
    return {
      api,
      type: "staff",
    };
  },
  computed: {
    formatters() {
      const na = this.$t("staffPage.notAvailable");
      return {
        birthday: (value) => {
          if (!value) return na;
          return formatCompanyTime(value, "YYYY-MM-DD", value);
        },
        gender: (value) => {
          if (value === null || value === undefined) return na;
          // Backend sends boolean: true = Male, false = Female
          return value === true || value === 1
            ? this.$t("staffPage.genderShortMale")
            : this.$t("staffPage.genderShortFemale");
        },
        roles: (value) => {
          if (!value || !Array.isArray(value) || value.length === 0) return na;
          // Display role names joined by comma
          return value.map((role) => role.name || role).join(", ");
        },
        blacklisted_at: (value) => {
          if (!value) return na;
          return formatCompanyTime(value, "YYYY-MM-DD");
        },
        created_at: (value) => {
          if (!value) return na;
          return formatCompanyTime(value, "YYYY-MM-DD");
        },
      };
    },
    fieldsExtraAdd() {
      return {
        password: "v-text-field",
        profile_image: "choose-image-single",
        gender: "choose-gender",
        birthday: "choose-date",
        role_id: "choose-role-single",
      };
    },
    fieldsExtraEdit() {
      return {
        password: "v-text-field",
        profile_image: "choose-image-single",
        gender: "choose-gender",
        birthday: "choose-date",
        role_id: "choose-role-single",
      };
    },
    fieldsExtraMain() {
      return {
       /* role_id: (item) => {
          // Convert roles array to role_id for display
          if (item.roles && Array.isArray(item.roles) && item.roles.length > 0) {
            return item.roles[0].id;
          }
          return null;
        },*/
      };
    },
    editExtraData() {
      // This will be computed dynamically in the component
      return {};
    },
    titles() {
      return {
        id: this.$t("staffPage.id"),
        username: this.$t("staffPage.email"),
        first_name: this.$t("staffPage.firstName"),
        last_name: this.$t("staffPage.lastName"),
        gender: this.$t("staffPage.gender"),
        birthday: this.$t("staffPage.dateOfBirth"),
        phone_number: this.$t("staffPage.phoneNumber"),
        created_at: this.$t("staffPage.joinedAt"),
        profile_image: this.$t("staffPage.profileImage"),
        password: this.$t("staffPage.password"),
        role_id: this.$t("staffPage.role"),
        blacklisted_at: this.$t("staffPage.blacklistedAt"),
        blacklist_note: this.$t("staffPage.blacklistNote"),
      };
    },
    actionsExtraMain() {
      return {};
    },
  },
};
</script>
